const mapStyle = {
  mapBody: {
    borderRadius: "6px"
  },
  cardBody: {
    padding: "0"
  },
  card: {
    marginTop: "0",
    height: "calc(100vh - 8rem - 123px)" // = screen height - KPI height - top bar height
  }
};

export default mapStyle;
